import React from "react";
import { PRODUCT_STATUS } from "../utils";

/**
 * Action Buttons Component
 * Submit, Accept/Reject, Edit buttons based on status
 */
const ActionButtons = ({
  status,
  isEditing,
  onSubmit,
  onStatusChange,
  onEdit,
  isSubmitting = false,
  isStatusChanging = false,
}) => {
  if (
    status === PRODUCT_STATUS.OPEN ||
    isEditing ||
    status === PRODUCT_STATUS.DRAFT
  ) {
    return (
      <div className="flex justify-center mt-8">
        <button
          type="button"
          onClick={onSubmit}
          disabled={isSubmitting}
          className="px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 transition-all shadow-md disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {isSubmitting ? (
            <>
              <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
              </svg>
              Submitting...
            </>
          ) : (
            "Submit Product"
          )}
        </button>
      </div>
    );
  }

  if (status === PRODUCT_STATUS.PENDING) {
    return (
      <div className="flex justify-center gap-4 mt-8">
        <button
          type="button"
          onClick={() => onStatusChange("accept")}
          disabled={isStatusChanging}
          className="px-8 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 focus:ring-4 focus:ring-green-300 transition-all shadow-md disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {isStatusChanging ? (
            <>
              <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
              </svg>
              Processing...
            </>
          ) : (
            "Accept"
          )}
        </button>
        <button
          type="button"
          onClick={() => onStatusChange("reject")}
          disabled={isStatusChanging}
          className="px-8 py-3 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 focus:ring-4 focus:ring-red-300 transition-all shadow-md disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {isStatusChanging ? (
            <>
              <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
              </svg>
              Processing...
            </>
          ) : (
            "Reject"
          )}
        </button>
      </div>
    );
  }

  if (
    (status === PRODUCT_STATUS.APPROVED ||
      status === PRODUCT_STATUS.REJECTED) &&
    !isEditing
  ) {
    return (
      <div className="flex justify-center mt-8">
        <button
          type="button"
          onClick={onEdit}
          disabled={isSubmitting}
          className="px-8 py-3 bg-yellow-600 text-white font-semibold rounded-lg hover:bg-yellow-700 focus:ring-4 focus:ring-yellow-300 transition-all shadow-md disabled:opacity-60 disabled:cursor-not-allowed"
        >
          Edit Product
        </button>
      </div>
    );
  }

  return null;
};

export default ActionButtons;
